import {MenuItem} from '@/store/types'
import {RouteConfig} from 'vue-router';

export function menu (): MenuItem[] {
    return [
        {
            title: 'Usuarios',
            icon: 'mdi-account',
            routeName: 'user-list',
            module: 'user',
            requireAuthorization: true,
            permission: '@/user/admin',
        },
    ]
}

export function routes (): RouteConfig[] {
    return [
        {
            name: 'user-list',
            path: '/usuarios',
            component: () => import('@/modules/user/components/UserList.vue'),
            props: {
              displayActions: true,
              elevation: 'elevation-2',
            },
            meta: {
                module: 'user',
                authRequired: true,
                toolbarTitle: 'Usuarios',
                vuex: {
                    loadModules: ['user'],
                },
            },
        },
        {
            name: 'user-detail',
            path: '/usuarios/:id',
            component: () => import('@/modules/user/components/UserDetail.vue'),
            meta: {
                module: 'user.userDetail',
                authRequired: true,
                toolbarTitle: 'Ver/editar usuario',
                vuex: {
                    loadModules: ['user'],
                },
            },
        },
        {
            name: 'user-groups',
            path: '/grupos-de-usuarios',
            component: () => import('@/modules/user/components/UserGroup/UserGroupList.vue'),
            meta: {
                module: 'user.userDetail',
                authRequired: true,
                toolbarTitle: 'Grupos de usuarios',
                vuex: {
                    loadModules: ['user'],
                },
            },
        },
        {
            name: 'user-group',
            path: '/grupos-de-usuarios/:id',
            component: () => import('@/modules/user/components/UserGroup/UserGroupDetail.vue'),
            meta: {
                module: 'user.userDetail',
                authRequired: true,
                toolbarTitle: 'Ver/editar grupo',
                vuex: {
                    loadModules: ['user'],
                },
            },
        },
    ]
}
